import {EventBackToTopButton} from "@/common/configurations/event-bus";
import {sendEmail, uploadEmailAttachment} from "@/common/services/common-request-service";
import {NOTIFICATION_TYPE} from "@/common/utils/constants";
import * as STATISTIC_SERVICE from "@/common/services/statistic-service";

const reportAProblemMixin = {
	data() {
		return {
			showSendReportDialog: false,
			sending: false,
			isMobileDevice: false,
		}
	},
	methods: {
		handleReportDialogShow(event) {
			if (event.target.id === "report" || event.target.classList.contains('show-dialog')) {
				this.showSendReportDialog = true;

				if (this.isMobileDevice) {
					EventBackToTopButton.$emit('toggleButton');
				}
			}
		},
		handleReportDialogClose() {
			this.showSendReportDialog = false;
			EventBackToTopButton.$emit('closeDialog');
			if (this.isMobileDevice) {
				EventBackToTopButton.$emit('toggleButton');
			}
		},
		sendEmailForProblem(message) {
			const vue = this;
			this.sending = true;
			this.$store.dispatch('showLoading');

			if (message.image?.value?.get?.('file')) {
				const newFormData = new FormData();
				newFormData.append('file', message.image.value.get('file'));
				uploadEmailAttachment(newFormData).then((response) => {
					const uploadedFileUrl = response.data.url
					this.sendEmail(uploadedFileUrl, message);
				})
					.catch((error) => {
						console.error(error);
						vue.sending = false;
					});
			} else {
				this.sendEmail(null, message);
			}
		},
		sendEmail(uploadedFileUrl, message){
			const vue = this;
			const body = {
				from: vue.$store.getters.getUser.email,
				title: `DRC - reported problem`,
				isDRC: true,
				to: {
					emails: ['vasil.ayvazov@akkodis.com', "petar.stoyanov@akkodis.com", "desislava.aleksandrova@akkodis.com", "plamen.velichkov@akkodis.com", "sabiha.mangova@akkodis.com", "pavlina.venkova@akkodis.com"]
				},
				message: `Reported problem: <br><br>
								<div style="margin: 10px;">Problem page name: ${vue.$route.name}</div>
								<div style="margin: 10px;">Problem page: ${vue.$route.path}</div>
								<div style="margin: 10px;">Problem topic: ${message.topic.value?.[0]?.name || 'Other'}</div>
								<div style="margin: 10px;">Problem description: ${message.description.value}</div>`
			}
			if(uploadedFileUrl){
				body.message += `<img src="${uploadedFileUrl}" alt="image"/>`
			}

			sendEmail(body).then(() => {
				vue.showNotification(`${vue.$t(`notifications.successfullyReportedProblem`)}`, NOTIFICATION_TYPE.SUCCESS);
				const props = {
					action: STATISTIC_SERVICE.ACTIONS.COMMON.REPORT_PROBLEM,
					comment: JSON.stringify({current_route: `${window.location.href}`})
				}
				STATISTIC_SERVICE.addDrcStatistic(props)
			})
				.catch((error) => {
					console.error(error);
				})
				.finally(() => {
					vue.$store.dispatch('hideLoading');
					vue.handleReportDialogClose();
					vue.sending = false;
				})
		},
	}
}

export default reportAProblemMixin;
